import { render, staticRenderFns } from "./CameraNew.vue?vue&type=template&id=5629eeb5&scoped=true&"
import script from "./CameraNew.vue?vue&type=script&lang=js&"
export * from "./CameraNew.vue?vue&type=script&lang=js&"
import style0 from "./CameraNew.vue?vue&type=style&index=0&id=5629eeb5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5629eeb5",
  null
  
)

export default component.exports